import { FirebaseAuth } from "utils/firebase";

// The signed-in user's people directory from the webhook: org roster, org
// members, and everyone they met or emailed in the last 90 days.
export async function fetchContactDirectory({ signal } = {}) {
  const token = await FirebaseAuth.currentUser?.getIdToken();
  if (!token) return [];
  const response = await fetch(
    process.env.REACT_APP_GT_WEBHOOK_API_URL + "/contacts",
    {
      cache: "no-store",
      signal,
      headers: { authorization: "Bearer " + token },
    },
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || "Suggestions are unavailable right now");
  return Array.isArray(data.contacts) ? data.contacts : [];
}
